import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import customAxios from "../service/axios";
import AppService from "../service/appService";
import UserService from "../service/userService";
Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		base_url: "https://api.appmastery.co/api/v1/apps",
		loader: false,
		loaderText: {
			show: false,
			text: "",
		},
		reset: {
			token: null,
			email: null,
			password: null,
			telephone: null,
			code: null,
		},
		accessToken: "",
		btClientToken: "",
		tempUserToken: "",
		regularcarousel: [],
		customerid: "5e72a0c611394600192020e0",
		globalconfigs: null,
		upComingVideos: null,
		amToken: "",
		showdefaultnav: false,
		showdefaultFooter: false,
		showPopup: false,
		showSpecialPopUp: false,
		popupType: "add_subscription",
		packages: null,
		showhome: false,
		showpackage: false,
		search: {
			currenSearchData: null,
			message: "",
		},
		player: {
			options: null,
		},
		currentPackage: {
			currentParent: null,
			currentSubs: null,
			currentPaymentSelected: null,
		},
		user: {
			logedin: false,
			accessToken: "",
			userInfo: [],
			mylist: [],
			resumelist: [],
			showMylist: false,
			regmobile: null,
		},
		registerData: null,
		notification: {
			show: false,
			text: "",
		},
		smsTriggerAttempt: 0,
		showOtpTimer: false,
		displayMode: "light",
		isCastingOn: false,
		cjs: null,
		lastAccountCallTime: 0,
		lastAccountCallResponse: {},
	},
	mutations: {
		setGlobalConfigs(state, payload) {
			this.state.globalconfigs = payload.response;
		},
		setPackageRoute(state, payload) {
			this.state.showhome = payload;
		},
		setAMToken(state, payload) {
			this.state.amToken = payload.token;
		},
		setuseraccesstoken(state, payload) {
			this.state.user.accessToken = payload;
			//this.state.user.logedin = true;
			localStorage.setItem("userAccessToken", payload);
		},
		setuserLoggedIn(state, payload) {
			this.state.user.logedin = payload;
		},
		setLoader(state, payload) {
			this.state.loader = payload;
		},
		setloaderText(state, payload) {
			this.state.loaderText.show = payload.value;
			this.state.loaderText.text = payload.text;
		},
		setPlayerData(state, payload) {
			this.state.player.options = payload;
		},
		logoutUser(state) {
			this.state.user.accessToken = null;
			this.state.user.logedin = false;
		},
		setmylistData(state, payload) {
			this.state.user.mylist = payload;
		},
		setresumelistData(state, payload) {
			this.state.user.resumelist = payload;
		},
		setpackages(state, payload) {
			this.state.packages = payload.response.packages;
			this.state.showpackage = true;
		},
		showdefaultnav(state, payload) {
			this.state.showdefaultnav = payload;
		},
		showdefaultFooter(state, payload) {
			this.state.showdefaultFooter = payload;
		},
		showPopup(state, payload) {
			this.state.showPopup = payload;
		},
		showSpecialPopUp(state, payload) {
			this.state.showSpecialPopUp = payload;
		},
		setPopupType(state, payload) {
			this.state.popupType = payload;
		},
		refreshMyList(state, payload) {
			this.state.user.showMylist = payload;
		},
		setUserpackages(state, payload) {
			this.state.currentPackage.currentParent = payload.currentParent;
			this.state.currentPackage.currentSubs = payload.currentSubs;
			this.state.currentPackage.currentPaymentSelected =
				payload.currentPaymentSelected;
		},
		updateSearchMessage(state, payload) {
			this.state.search.message = payload;
		},
		updateSearchData(state, payload) {
			this.state.search.currenSearchData = payload;
		},
		userregmobile(state, payload) {
			this.state.user.regmobile = payload;
		},
		updateResetField(state, payload) {
			this.state.reset[payload.type] = payload.value;
		},
		getResetInfo(state) {},
		setRegisterData(state, payload) {
			this.state.registerData = payload;
		},
		setNotification(state, payload) {
			this.state.notification.text = payload;
			this.state.notification.show = true;
			var self = this;
			setTimeout(function() {
				self.state.notification.text = payload;
				self.state.notification.show = false;
			}, 5000);
		},
		setBTClientToken(state, payload) {
			this.state.btClientToken = payload;
		},
		setNonceToken(state, payload) {
			this.state.nonceToken = payload;
		},
		tempUserToken(state, payload) {
			this.state.tempUserToken = payload;
		},
		setUpComingVideos(state, payload) {
			this.state.upComingVideos = payload.response;
		},
		setSmsTriggerAttempt(state, payload) {
			this.state.smsTriggerAttempt = payload;
		},
		setShowOtpTimer(state, payload) {
			this.state.showOtpTimer = payload;
		},
		setDisplayMode(state, payload) {
			if (payload) {
				this.state.displayMode = "dark";
				localStorage.setItem("displayMode", "dark");
			} else {
				this.state.displayMode = "light";
				localStorage.setItem("displayMode", "light");
			}
			document.documentElement.className = state.displayMode;
		},
		setUserId(state, payload) {
			this.state.user.userInfo.userid = payload;
		},
		setUserInfo(state, payload) {
			this.state.user.userInfo = payload;
		},
		setIsCastingOn(state, payload) {
			this.state.isCastingOn = payload;
		},
		setCjs(state, payload) {
			this.state.cjs = payload;
		},
		setAccountResponse(state, payload) {
			this.state.lastAccountCallResponse = payload;
		},
	},
	getters: {
		getGlobalConfigs: (state) => state.globalconfigs,
		isCountryDpoWhiteListed(state) {
			return true;
		},

		isCountryWhiteListed(state) {
			const countrycode = state.globalconfigs.country_code;
			const paymentOptions = state.globalconfigs.payment_options;
			const CountryWhiteListed = JSON.parse(
				state.globalconfigs.flutterwave_countries
			).find((arr) => {
				if (countrycode == arr) {
					return true;
				} else {
					return false;
				}
			});
			return CountryWhiteListed ? true : false;
		},
		isCountryStripeWhiteListed(state) {
			const countrycode = state.globalconfigs.country_code;
			const CountryWhiteListed = JSON.parse(
				state.globalconfigs.stripe_countries
			).find((arr) => {
				if (countrycode == arr) {
					return true;
				} else {
					return false;
				}
			});
			return CountryWhiteListed ? true : false;
		},
		isCountryBraintreeWhiteListed(state) {
			const countrycode = state.globalconfigs.country_code;
			const CountryWhiteListed = JSON.parse(
				state.globalconfigs.braintree_countries
			).find((arr) => {
				if (countrycode == arr) {
					return true;
				} else {
					return false;
				}
			});
			return CountryWhiteListed ? true : false;
		},
		getPackages: (state) => state.packages,
		isvideoResume: (state) => (id) => {
			const resumeVideo = state.user.resumelist?.find(
				(video) => video.video_id === id
			);
			return resumeVideo ? true : false;
		},
		getresumeTimeById: (state) => (id) => {
			const resumeVideo = state.user.resumelist?.find(
				(video) => video.video_id === id
			);
			return resumeVideo ? resumeVideo.resumeTime : null;
		},
		getUpComingVideos: (state) => state.upComingVideos,
		getBTClientToken: (state) => state.btClientToken,
		gettempUserToken: (state) => state.tempUserToken,
		getSmsTriggerAttempt: (state) => state.smsTriggerAttempt,
		getShowOtpTimer: (state) => state.showOtpTimer,
		getDisplayMode(state) {
			return state.displayMode;
		},
		getUserId(state) {
			return state.user.userInfo.userid;
		},
		getUserInfo(state, payload) {
			return state.user.userInfo;
		},
		getIsCastingOn(state) {
			return state.isCastingOn;
		},
		getCjs(state) {
			return state.cjs;
		},
	},
	actions: {
		login({ commit }, payload) {
			return new Promise((resolve, reject) => {
				if (payload.type) {
					var dataToSend = { username: payload.id, password: payload.password };
				}
				var self = this;
				var shajs = require("sha.js");
				var password = shajs("sha256")
					.update(dataToSend.password)
					.digest("hex");
				dataToSend.password = password;
				customAxios({
					method: "post",
					url: "/login",
					data: dataToSend,
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit(
								"setuseraccesstoken",
								response.data.response.user_token
							);
							UserService.cleanUserData();
							UserService.setUserData(response.data.response.user_token);
							resolve(response.data);
							// self.dispatch("account").then((res) => {
							// 	resolve(response.data);
							// });
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		socialLogin({ commit }, payload) {
			return new Promise((resolve, reject) => {
				var dataToSend = payload;
				var self = this;
				customAxios({
					method: "post",
					url: "/social-login",
					data: dataToSend,
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit(
								"setuseraccesstoken",
								response.data.response.user_token
							);
							UserService.cleanUserData();
							UserService.setUserData(response.data.response.user_token);
							resolve(response.data);
							self.dispatch("account").then((res) => {
								resolve(response.data);
							});
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		socialSignup({ commit }, payload) {
			return new Promise((resolve, reject) => {
				var dataToSend = payload;
				var self = this;
				customAxios({
					method: "post",
					url: "/social-register",
					data: dataToSend,
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit("setuseraccesstoken", response.data.user_token);
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		contactus({ commit }, data) {
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/contactus",
					data: data,
					headers: {
						authorization: this.state.user.accessToken,
						customerid: this.state.customerid,
						"Content-Type": "application/json",
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		account({ commit }, data) {
			self = this;
			return new Promise((resolve, reject) => {
				const currentTime = Date.now();
				if (
					currentTime - self.state.lastAccountCallTime > 30000 ||
					(data && data.forceFetch)
				) {
					customAxios({
						method: "get",
						url: "/account",
						headers: {
							customerid: this.state.customerid,
							authorization: this.state.user.accessToken,
						},
					})
						.then(function(response) {
							self.state.lastAccountCallTime = Date.now();
							if (response.status == 200) {
								self.commit("setAccountResponse", response.data);
								resolve(response.data);
								self.state.user.userInfo = response.data.response;
								self.commit("setUserInfo", response.data.response);
								self.commit("setUserId", self.state.user.userInfo.userid);

								self.dispatch("myList");
								self.dispatch("getResumeVideo");
								if (self.state.user.userInfo.subscriptionHistory == false) {
									self.commit("setPopupType", "add_subscription");
								} else if (
									self.state.user.userInfo.subscriptionHistory == true &&
									self.state.user.userInfo.subscriptions.length == 0 &&
									self.state.user.userInfo.recurring == true
								) {
									self.commit("setPopupType", "renew_subscription");
								}
							}
							reject(response);
						})
						.catch(function(error, response) {
							self.state.lastAccountCallTime = Date.now();
							reject(error);
						});
				} else {
					resolve(self.state.lastAccountCallResponse);
				}
			});
		},
		myList({ commit }, data) {
			self = this;
			this.commit("refreshMyList", false);
			return new Promise((resolve, reject) => {
				customAxios({
					method: "get",
					url: "/mylist",
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit("setmylistData", response.data._embedded.collections);
							self.commit("refreshMyList", true);

							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		updatemyList({ commit }, data) {
			self = this;
			var MydataList = {
				video_id: data.id,
				status: 0,
			};
			if (data.value === true) {
				MydataList.status = 1;
			} else {
				MydataList.status = 0;
			}
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/mylist",
					data: MydataList,
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							//self.state.user.mylist = response.data._embedded.collections;
							resolve(response.data);
							self.dispatch("myList");
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		voteVideo({ commit }, data) {
			self = this;
			var MydataList = {
				video_id: data.id,
				type: "",
			};
			if (data.status === true) {
				MydataList.type = "UP";
			} else {
				MydataList.type = "DOWN";
			}
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/vote-video",
					data: MydataList,
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
						"Content-Type": "application/json",
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit("setNotification", response.data.message);
							resolve(response.data);
							//  self.dispatch('myList');
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		conformUser({ commit }, data) {
			var paramtext = "" + data.username + "?token=" + data.token;
			self = this;
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/confirm/" + paramtext,
					headers: {
						customerid: this.state.customerid,
						"content-type": "application/json",
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		forgetpassword({ commit }, data) {
			self = this;
			var dataToSend = data;
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/reset",
					headers: {
						customerid: this.state.customerid,
						"content-type": "application/json",
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		resetpassword({ commit }, data) {
			self = this;
			var self = this;
			var shajs = require("sha.js");
			var storeData = this.state.reset;
			var password = shajs("sha256")
				.update(storeData.password)
				.digest("hex");
			var dataToSend = {
				userId: storeData.email,
				token: storeData.token,
				password: password,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/update-password",
					headers: {
						customerid: this.state.customerid,
						"content-type": "application/json",
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		resetpasswordPhone({ commit }) {
			self = this;
			var self = this;
			var shajs = require("sha.js");
			var storeData = this.state.reset;
			var password = shajs("sha256")
				.update(storeData.password)
				.digest("hex");
			var dataToSend = {
				code: storeData.code,
				token: storeData.token,
				password: password,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/update-password-mobile",
					headers: {
						customerid: this.state.customerid,
						"content-type": "application/json",
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		updatepassword({ commit }, data) {
			self = this;
			var self = this;
			var shajs = require("sha.js");
			var password = shajs("sha256")
				.update(data.password)
				.digest("hex");
			var passwordold = shajs("sha256")
				.update(data.oldPassword)
				.digest("hex");
			var dataToSend = {
				oldPassword: passwordold,
				password: password,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/change-password",
					headers: {
						customerid: this.state.customerid,
						"content-type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		ChangeSubscription({ commit, state }, payload) {
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/update-user-subscription",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: payload,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		UpdatePhone({ commit }, data) {
			var dataToSend = {
				telephone: data.telephone,
				metaData: data.metaData,
				first_name: data.firstName,
				last_name: data.lastName,
				email_address: data.email,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "patch",
					url: "/update-profile",
					headers: {
						customerid: this.state.customerid,
						"content-type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getClientToken({ commit, state }, payload) {
			var self = this;
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/get-client-token",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: payload.token,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getClientStripeToken({ commit, state }, payload) {
			var self = this;
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/get-client-token",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: payload,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},

		UpdateEmail({ commit }, data) {
			var dataToSend = {
				metaData: data.metaData,
				first_name: data.firstName,
				last_name: data.lastName,
				username: data.email,
				email_address: data.email1,
				telephone: data.telephone,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "patch",
					url: "/update-profile",
					headers: {
						customerid: this.state.customerid,
						"content-type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		UpdateProfile({ commit }, data) {
			var dataToSend = {
				metaData: data.metaData,
				first_name: data.firstName,
				last_name: data.lastName,
				telephone: data.telephone,
				email_address: data.email,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "patch",
					url: "/update-profile",
					headers: {
						customerid: this.state.customerid,
						"content-type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getCatalougeById({ commit }, data) {
			return new Promise((resolve, reject) => {
				customAxios({
					method: "get",
					url: "/catalogues?id=" + data,
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
							this.state.regularcarousel = response.data._embedded.items;
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getVideoById({ commit }, data) {
			return new Promise((resolve, reject) => {
				customAxios({
					method: "get",
					url: "/video?id=" + data,
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
							this.state.regularcarousel = response.data._embedded.items;
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getblogsByTag({ commit }, data) {
			return new Promise((resolve, reject) => {
				customAxios({
					method: "get",
					url: "/blogs?tags[]=" + data,
					headers: {
						"content-type": "application/json",
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
							this.state.regularcarousel = response.data._embedded.items;
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getPackages({ commit }, data) {
			return new Promise((resolve, reject) => {
				var self = this;
				customAxios({
					method: "get",
					url: "/packages",
					headers: {
						customerid: this.state.customerid,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit("setpackages", response.data);
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getVideoPlaybackURL({ commit }, data) {
			return new Promise((resolve, reject) => {
				axios({
					method: "get",
					url: data,
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		search({ commit }, data) {
			return new Promise((resolve, reject) => {
				customAxios({
					method: "get",
					url: "/searchvideo?query=" + data,
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve([response.data, data]);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getCatalougeByURL({ commit }, data) {},
		getToken({ commit }) {
			var self = this;
			return new Promise((resolve, reject) => {
				var data = { platform: "website", customerId: this.state.customerid };
				customAxios({
					method: "post",
					url: "/get-token",
					headers: { "content-type": "application/json" },
					data: data,
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit("setAMToken", response.data);
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getConfig({ commit }) {
			var self = this;
			return new Promise((resolve, reject) => {
				var data = { platform: "website" };
				customAxios({
					method: "get",
					url: "/appconfig",
					headers: {
						customerId: this.state.customerid,
						authorization: this.state.amToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit("setGlobalConfigs", response.data);
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		isUserauthenticated({ commit }) {
			if (UserService.isUserAuthenticated()) {
				this.commit("setuseraccesstoken", UserService.getUserToken());
				this.dispatch("account");
				this.commit("setuserLoggedIn", UserService.getUserToken());
			}
		},
		logout({ commit }) {
			var self = this;
			return new Promise((resolve, reject) => {
				UserService.cleanUserData();
				self.commit("logoutUser");
				resolve("true");
			});
		},
		signup({ commit }, payload) {
			return new Promise((resolve, reject) => {
				const registerData = payload;
				var shajs = require("sha.js");
				var hashed = shajs("sha256")
					.update(registerData.password)
					.digest("hex");
				if (payload.type == "number") {
					var regData = {
						first_name: registerData.name,
						last_name: registerData.lastname,
						telephone: registerData.telephone,
						username: registerData.telephone,
						password: hashed,
						metaData: registerData.metadata,
					};
				} else {
					var regData = {
						first_name: registerData.name,
						last_name: registerData.lastname,
						email_address: registerData.email,
						username: registerData.email,
						telephone: registerData.telephone,
						password: hashed,
						metaData: registerData.metadata,
					};
				}

				var self = this;
				var shajs = require("sha.js");
				customAxios({
					method: "post",
					url: "/register",
					data: regData,
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit("setuseraccesstoken", response.data.user_token);
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		verifyEMAIL({ commit }, payload) {
			var dataToSend = { username: payload.username, token: payload.token };
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/confirm/" + payload.username + "?token=" + payload.token,
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
							self.commit("setPackageRoute", false);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		verifySMS({ commit }, payload) {
			var dataToSend = { telephone: payload.telephone, code: payload.code };
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/confirm-mobile",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		processSubsflutterWave({ commit, state }, payload) {
			var UserAccessToken = state.tempUserToken;
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/process-subscription",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: UserAccessToken,
					},
					data: payload,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		processSubs({ commit, state }, payload) {
			var UserAccessToken = state.tempUserToken;
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/process-subscription",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: UserAccessToken,
					},
					data: payload,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getSubscription({ commit }, payload) {
			var dataToSend = {
				transaction_id: payload.transaction_id,
				slug: payload.slug,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/get-subscription",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},

		cancleSubsById({ commit }, payload) {
			var dataToSend = {
				id: payload.id,
				subscriptionId: payload.subscriptionId,
				slug: payload.slug,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/cancel-subscription",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		triggerEmailverify({ commit }, payload) {
			var dataToSend = { email_address: payload.email };
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/trigger-email-verification",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		triggerSMSverify({ commit }, payload) {
			var dataToSend = {
				telephone: payload.telephone,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/trigger-mobile-verification",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},

		DpoPaymentProcess({ commit, state }, payload) {
			localStorage.setItem("pid", payload.pid);
			localStorage.setItem("sid", payload.sid);
			var UserAccessToken = state.tempUserToken;
			var dataToSend = {
				slug: "dpo",
				slug_name: payload.slug,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/add-subscription",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: UserAccessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},

		FlutterWavePaymentProcess({ commit, state }, payload) {
			var UserAccessToken = state.tempUserToken;
			var dataToSend = {
				slug: payload.slug,
				provider_slug: payload.provider_slug,
				type: payload.type,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/process-payment",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: UserAccessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		DpoVerifyPayment({ commit, state }, payload) {
			var UserAccessToken = localStorage.getItem("userAccessToken");

			var dataToSend = {
				subscriptionId: payload.subscriptionId,
				transactionId: payload.transactionId,
				transactionToken: payload.transactionToken,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/verify-payment-token",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: UserAccessToken,
					},

					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		FlutterWaveVerifyPayment({ commit, state }, payload) {
			var UserAccessToken = localStorage.getItem("userAccessToken");

			var dataToSend = {
				tx_ref: payload.tx_ref,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/verify-payment",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: UserAccessToken,
					},

					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		setResumeVideo({ commit, state }, payload) {
			return new Promise((resolve, reject) => {
				customAxios({
					method: "post",
					url: "/resume",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: payload,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},

		getResumeVideo({ commit, state }) {
			commit("setresumelistData", []);
			return new Promise((resolve, reject) => {
				customAxios({
					method: "get",
					url: "/get-resume-list",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							commit("setresumelistData", response.data.resumeList);
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getVideoPlaybackURLV2({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios({
					method: "get",
					url:
						"https://api.appmastery.co/api/v2/apps/videoplayback?id=" +
						payload.videoId +
						"&deviceId=" +
						payload.deviceId,
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getStripeToken({ commit }) {
			var dataToSend = {
				slug: "stripe",
			};
			return new Promise((resolve, reject) => {
				axios({
					method: "POST",
					url: "https://api.appmastery.co/api/v2/apps/payment-user-token",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		stripePaymentProcess({ commit }, paymentMethod) {
			var dataToSend = {
				paymentMethodNonce: paymentMethod.id,
				slug: "stripe",
			};
			return new Promise((resolve, reject) => {
				axios({
					method: "POST",
					url: "https://api.appmastery.co/api/v2/apps/add-payment-method",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		stripeAddSubscription({ commit }, payload) {
			var dataToSend = {
				subscriptionId: payload.id,
			};
			return new Promise((resolve, reject) => {
				axios({
					method: "POST",
					url: "https://api.appmastery.co/api/v2/apps/add-subscription",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		retryPayment({ commit }, payload) {
			var dataToSend = {
				subscriptionId: payload.subscriptionId,
				slug: payload.slug,
			};
			return new Promise((resolve, reject) => {
				axios({
					method: "POST",
					url: "https://api.appmastery.co/api/v2/apps/retry-subscription",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		stripeCheckout({ commit }, payload) {
			var dataToSend = {
				subscriptionId: payload.id,
				payment_method_type: ["card"],
				coupon: payload.coupon,
			};
			return new Promise((resolve, reject) => {
				axios({
					method: "POST",
					url: "https://api.appmastery.co/api/v2/apps/checkout-page",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		addPaymentProcess({ commit }, dataToSend) {
			var dataToSend = {
				paymentMethodNonce: dataToSend.id,
				slug: "braintree",
			};
			return new Promise((resolve, reject) => {
				axios({
					method: "POST",
					url: "https://api.appmastery.co/api/v2/apps/add-payment-method",
					headers: {
						customerid: this.state.customerid,
						"Content-Type": "application/json",
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		getUpComingVideos({ commit }) {
			var self = this;
			return new Promise((resolve, reject) => {
				customAxios({
					method: "get",
					url: "/upcoming-video",
					headers: {
						customerId: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							self.commit("setUpComingVideos", response.data);
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		deleteAccount({ commit, state }) {
			return new Promise((resolve, reject) => {
				customAxios({
					method: "DELETE",
					url: "/delete-user",
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
		verifyRecaptchaToken({ commit, state }, payload) {
			let dataToSend = {
				token: payload,
			};
			return new Promise((resolve, reject) => {
				customAxios({
					method: "POST",
					url:
						"https://ctvgv40nsa.execute-api.us-west-2.amazonaws.com/default/ibakatv-recaptcha",
					headers: {
						customerid: this.state.customerid,
						authorization: this.state.user.accessToken,
					},
					data: dataToSend,
				})
					.then(function(response) {
						if (response.status == 200) {
							resolve(response.data);
						}
						reject(response);
					})
					.catch(function(error, response) {
						reject(error);
					});
			});
		},
	},
});
